/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject, Pipe, PipeTransform } from '@angular/core';

// Service
import { CommonService } from '../../../core/services/common/common.service';

@Pipe({
  name: 'filter',
  standalone: false,
})
export class FilterPipe implements PipeTransform {
  private readonly common = inject(CommonService);

  transform(items: any, filter: any, isAnd: boolean = false): any {
    if (filter && Array.isArray(items)) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      const filterKeys = Object.keys(filter);

      if (isAnd) {
        return items.filter((item) =>
          filterKeys.reduce(
            (memo, keyName: string) =>
              // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
              (memo && new RegExp(filter[keyName], 'gi').test(item[keyName])) || filter[keyName] === '',
            true,
          ),
        );
      } else {
        return items.filter((item) => {
          return filterKeys.some((keyName) => {
            if (keyName === 'LABELSINLANGUAGE') {
              const TRANSLATED_LABEL = item[keyName][this.common.currentLang] as string;

              // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
              return new RegExp(filter[keyName], 'gi').test(TRANSLATED_LABEL) || filter[keyName] === '';
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            return new RegExp(filter[keyName], 'gi').test(item[keyName]) || filter[keyName] === '';
          });
        });
      }
    } else {
      return items;
    }
  }
}
